import React, { useEffect, useState } from 'react';
import TemplateGroup from './TemplateGroup/TemplateGroup';
import {
   CollectionPickerContainer,
   CollectionPickerMobileWrapper,
   CollectionPickerTemplateGroup,
   CollectionPickerWrapper,
   CollectionPickerMobileOverlay
} from './CollectionsPicker.styled';
import CollectionsPickerMobile from './CollectionsPickerMobile';
import { selectCollection, setSelectedTemplate } from '../../../redux/reducers/collectionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import config from './../../../config';
import { useWindowSize } from '../../../helpers/hooks/useWindowSize';

const CollectionsPicker: React.FC = props => {
   const [hidden, setHidden] = useState(true);
   const router = useRouter();
   const dispatch = useDispatch();
   const { id, name, type, groups, selectedTemplateId, selectedTemplateName, params, isLoaded } = useSelector(selectCollection);
   const isMobile = useWindowSize().isMobile;

   const onClick = (type: string, collectionId: string, newTemplateId: string, oldTemplateId: string) => {
      if (newTemplateId != oldTemplateId) {
         router.push(`${config.baseName}/${collectionId}/${newTemplateId}`, undefined, { shallow: true });

         dispatch(setSelectedTemplate(newTemplateId));

         if (isMobile) {
            toggleCollectionPickerVisibility();
         }
      }
   };

   const onLoad = (type: string, collectionId: string, templateId: string) => {
      // we need to do an actual redirect, so that Aamplitude reads the page load correctly
      // this will cause 2 `Page View` events in Amplitude, but we will take a story later to fix links in the landing page
      // which will fix the redirection issue, thereby fixing 2 `Page View` events in Amplitude
      window.location.href = `${config.iiHomeUrl}${config.baseName}/${collectionId}/${templateId}`;
   };

   useEffect(() => {
      if (!params.templateId) onLoad(type, id, selectedTemplateId);
   }, []);

   const toggleCollectionPickerVisibility = () => {
      setHidden(!hidden);
   };

   const templateGroups = groups.map((group, index) => (
      <TemplateGroup key={index} collectionId={id} selectedTemplateId={selectedTemplateId} group={group} collectionType={type} onClick={onClick} />
   ));

   return (
      <CollectionPickerWrapper>
         <CollectionPickerMobileWrapper onClick={() => toggleCollectionPickerVisibility()}>
            <CollectionsPickerMobile hidden={hidden} title={selectedTemplateName} />
         </CollectionPickerMobileWrapper>
         {!hidden && isMobile && <CollectionPickerMobileOverlay onClick={() => toggleCollectionPickerVisibility()} />}
         <CollectionPickerContainer active={hidden}>
            <CollectionPickerTemplateGroup justifyContent='start' alignItems='start' spaceBetween={24} active={hidden}>
               {templateGroups}
            </CollectionPickerTemplateGroup>
         </CollectionPickerContainer>
      </CollectionPickerWrapper>
   );
};

export default CollectionsPicker;
